<form [formGroup]="formGroup">
  <div class="single-choice-question" fxFlexFill fxLayout="row">
    <div fxFlex fxLayout="column" fxLayoutGap="10px">
      <div fxFlex="30px">{{questionMeta.text}}</div>
      <div fxFlex fxLayout="row wrap" fxLayoutGap="20px grid">
        <div fxFlex="45" *ngFor="let choice of questionMeta.items">
          <div fxFlex="24px">
            <input type="radio" [name]="question.id" [value]="choice.value" (ngModelChange)="onChange($event)"
                   [formControlName]="question.id" kendoRadioButton/>
          </div>
          <div fxFlex fxLayout="column" fxLayoutGap="10px" >
            <div fxFlex>
              {{choice.text || ' '}}
            </div>
            <div fxFlex="75px" *ngIf="choice.image">
              <img [src]="choice.image" [width]="75" [height]="75"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
